import { render, staticRenderFns } from "./Vcalendar.vue?vue&type=template&id=0a205366&"
import script from "./Vcalendar.vue?vue&type=script&lang=js&"
export * from "./Vcalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports